import { forEach, isEmpty } from "lodash";
import { BASE_URL, DAY_SEMAINE, DAY_USE_HORAIRE_APRES_MIDI, DAY_USE_HORAIRE_MATIN } from "./constUtils";
import moment from "moment";
import dayjs from "dayjs";

/**
 * image ajouté propriété uid avec comme valeur l'id
 * pour corriger le warning <<Upload>>
 * @param {*} images 
 * @returns 
 */
export function addUid(images){
    let lists = [];
    images?.forEach((e)=>{
      e.uid = e.id;
      lists.push(e);
    })
    return lists;
}

/**
 * créer un tableau des ids à partir d'une liste d'objet
 * @param {*} listes 
 * @returns 
 */
export function listIds(listes) {
    let ids = [];
    listes?.forEach((e)=>{
        ids.push(parseInt(e.id));
    })
    return ids;
}

/**
 * afficher en chaines les libéllés des catégories
 * @param {*} categories 
 * @returns 
 */
export function toStringCategorieLibelle(categories){
    let elements = [];
    categories?.forEach((e)=>{
        elements.push(e?.libelle??(e?.libelleService??e?.description));
    })
    return elements.join(", ");
}

/**
 * fonction pour avoir l'id profil d'un utilisateur
 * @param {*} roles 
 * @returns 
 */
export function getRoleProfil(roles){
    let idProfil = 5;
    
    if(roles.includes('ROLE_SUPER_ADMIN')) {
      idProfil = 1; 
    } else if(roles.includes('ROLE_MANAGER')) {
      idProfil = 2;
    } else if(roles.includes('ROLE_AGENT_COM')) {
      idProfil = 3
    } else if(roles.includes('ROLE_ADMIN_HOTEL')) {
      idProfil = 4
    } 

    return idProfil;
}

/**
 * texte à afficher pour l'état de réservation
 * @param {*} etat 
 * @returns 
 */
export function textEtatReservation(etat){

  let text;
  switch(etat) {
    case 'ANNULE' :
      text = "Annulée";
      break;
    // case 'EN_ATTENTE_DE_VALIDATION' :
    //     text = "En attente de validation";
    //     break;
    case 'VALIDE' :
      text = "Validée";
      break;
    // case 'REJETE' :
    //   text = "Rejetée";
    //   break;
    case 'EFFECTIVE' :
      text = "Terminée";
      break;
    case 'CONFIRMEE' :
      text  = 'Confirmée';
      break;
      case 'A_REMBOURSE' :
        text = "A rembourser";
        break;
      case 'REMBOURSE' :
        text  = 'Remboursée';
        break;
    default : 
      text = "En cours";
      break;
  }

  return text;
}

export const listEtatReservation = [
  //{text:"En attente de validation",value:"EN_ATTENTE_DE_VALIDATION",id:2},
  {text:"Annulée",value:"ANNULE",id:5},
  {text:"En cours",value:"EN_COURS",id:1},
  {text:"Validée",value:"VALIDE",id:6},
  {text:"A rembourser",value:"A_REMBOURSE",id:7},
  {text:"Remboursée",value:"REMBOURSE",id:8},
  {text:"Terminée",value:"EFFECTIVE",id:4},
  {text:"Confirmée",value:"CONFIRMEE",id:3}
];

export const RESERVATION_STATUT_VALIDE = 'VALIDE';
export const RESERVATION_STATUT_CONFIRME = 'CONFIRMEE';
export const RESERVATION_STATUT_AREMBOURSE = 'A_REMBOURSE';
export const RESERVATION_STATUT_REMBOURSE = 'REMBOURSE';

export function dateToFr(date) {
  if (typeof date !== 'string') return '';

  let tmp = date.split('T');
  if (tmp.length < 2) {
    tmp = date.split(' ');
  }

  const [datePart, timePart] = tmp;

  const formattedDate = datePart?.split('-')?.reverse()?.join('/') ?? '';
  const formattedTime = timePart?.substring(0, 8) ?? '';

  return formattedTime ? `${formattedDate} ${formattedTime}` : formattedDate;
}


//get id en nombre pour trier le statut
export const idStatutReservation = (s)=>{
  let ret = 0;
  listEtatReservation?.forEach(({value,id}) =>
  {
    if(s===value) {
      ret = id;
    }
  });

  return ret;
}

/**
 * Lister les ids des éléments cochés
 * @param {*} items 
 * @returns 
 */
export function calculIdElementsChecked(items) {
  let list = [];
  items?.forEach((element)=>{
    if(element?.added) {
      list.push(element.id);
    }
  });
  return list;
}

export const isUserClient = (user) => {
  return user && user?.roles && user.roles.includes('ROLE_CLIENT');
}

/**
 * filtre résultat by idHotel
 * @param {*} list 
 * @param {*} idHotel 
 * @returns 
 */
export const filtreByHotel = (list,idHotel) => {
  if(idHotel>0) {
    let newList = [];
    list?.forEach(element => {
      if(element?.idHotel === idHotel) {
        newList.push(element);
      }
     
    });

    return newList;
  } 
  return list;
}

/**
 * 
 * @param {*} user 
 * @returns 
 */
export const getUserToken = (user) => {
  return user?.token;
}

/**
 * get id en nombre pour trier le statut
 * @param {*} s 
 * @returns 
 */
export  const getIdStatut = (listStatut,s)=>{
    let ret = 0;
    listStatut?.forEach(({value,id}) =>
    {
      if(s===value) {
        ret = id;
      }
    });

    return ret;
}


export const getPrixPromo = (prixInitial, remise)=>{
  let res = null ;
  if (remise){
    res = prixInitial - (prixInitial * remise / 100);
  }
  return res ; 
}


export const infoPromo = (offre) => {
  let info = null ; 
  if (offre && offre.length > 0){
    offre?.forEach((value,id) =>  {
      if (id == 0 )
        info = `Si vous réservez à partir du ${dateToFr(value.dateDebut)} au ${dateToFr(value.dateFin)} vous auriez une remise de ${value.remise}%`;
      else
        info += `\nSi vous réservez à partir du ${dateToFr(value.dateDebut)} au ${dateToFr(value.dateFin)} vous auriez une remise de ${value.remise}%`; 
    })
  }
  return info; 
}
/**
 * 
 * @param {*} currency 
 * @returns {number}
 */
export const getCurrencyId = (currency) => currency=='Ar' ? 1 : 2;

export const addPlural = (nb) => nb > 1 ? 's' : ''; 
export const getCurrencyLibelleByIdDevise = (idDevise) => idDevise === 1 ? 'Ariary' : 'Euro';

/**
 * 
 * @param {*} data //object
 */
export const createDaySemaineMapWithDataParams = (data) => {
  let daysData = {...data};
  const daySemaine = [...DAY_SEMAINE];

  const getConfigDay = (day, moment) => {
    return {
      jourSemaine: day,
      momentJournee: moment,
      checked: false,
      tarifs: [
        {
          idDevise: 1,
          prix: '',
          symbol: "Ar"
        },
        {
          idDevise: 2,
          prix: '',
          symbol: "Euro"
        }
      ]
    }
  }

  daySemaine.forEach(day => {
    if (!daysData[day.value]) {
      daysData = {
        ...daysData,
        [day.value]: {
          day: day.value,
          values: {
            matin: getConfigDay(day.value, DAY_USE_HORAIRE_MATIN),
            apres_midi: getConfigDay(day.value, 'APRES_MIDI'),
          }
        }
      }
    } else if (
      !!daysData[day.value] && !daysData[day.value].values.matin
    ) {
      daysData[day.value].values.matin = getConfigDay(day.value, DAY_USE_HORAIRE_MATIN);
    } else if (
      !!daysData[day.value] && !daysData[day.value].values.apres_midi
    ) {
      daysData[day.value].values.apres_midi = getConfigDay(day.value, DAY_USE_HORAIRE_APRES_MIDI);
    }

  });

  return daysData;
}

/**
 * 
 * @param {*} blob 
 * @param {*} filename 
 */
export const downloadFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}


export function isSejourInPeriodeDeOffre(debutSejour,finSejour,offre) {
  
  if(debutSejour !== null 
    && finSejour !==null
    && offre?.debutOffre !== null 
    && offre?.finOffre !== null){
    let a = moment(debutSejour, 'YYYY-MM-DD')?.isBefore(moment(offre?.debutOffre, 'YYYY-MM-DD'),"day");
    let b = moment(finSejour, 'YYYY-MM-DD')?.isAfter(moment(offre?.finOffre, 'YYYY-MM-DD'),"day");
    if(!a  && !b){
      return true
    }
  }
  return false;

}

export function getOffrePeriode(debutSejour,finSejour,remises) {
  let dates ={
    debutOffre:null,
    finOffre:null,
    taux:0
  };
  remises?.forEach((remise) => {
    let debutOffre = remise?.dateDebut;
    let finOffre = remise?.dateFin;
    let a = moment(debutSejour, 'YYYY-MM-DD')?.isBefore(moment(debutOffre, 'YYYY-MM-DD'),"day");
    let b = moment(finSejour, 'YYYY-MM-DD')?.isAfter(moment(finOffre, 'YYYY-MM-DD'),"day");
    if(!a  && !b){
      dates.taux = remise?.remise;
      dates.debutOffre = debutOffre;
      dates.finOffre = finOffre;
      return dates;
    }
  })
  return dates;
}

export const transformeFormImageData = (data) => {
  let arr = [];
  data?.forEach((item)=>{
    arr.push(item?.response?.[0]??item);
  })

  return arr;
}

export const formatDate = (dateString) => {
  const formattedDate = moment(dateString, 'YYYY-MM-DD').toDate().toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  return formattedDate;
};

export const stripHtmlTags = (text) => {
  return text===null?'':text?.replace(/&nbsp;/g, ' ')?.replace(/<[^>]*>|&[^;]+;/g, '');
}

export const getIconeUrl = (url) => {
  return `${BASE_URL}/${url}`;
}

export const getIconeUrlById = (id) => {
  return getIconeUrl(`icone/show?idIcone=${id}&image=`);
}

 // Formater les dates
export const formatDateToFr = (dateString) => {
  if (!dateString || !/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return "";

  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
};

export const convertDateFormat = (dateString) =>{
  // Diviser la date en jour, mois et année
  const [day, month, year] = dateString.split('-');
  
  // Créer un objet Date à partir des valeurs
  const date = new Date(year, month - 1, day); // Les mois commencent à 0 en JavaScript

  // Formater la date en YYYY-MM-DD
  const formattedDate = date.toISOString().split('T')[0]; // Extrait la partie date de l'ISO string
  
  return formattedDate;
}

export const orderByCartegorie = (list) => {
  return list.sort((a, b) => a?.categorie.localeCompare(b?.categorie));
}

/**
 * Cette fonction remplace \n par <br> pour le retour à la ligne
 * @param {*} str 
 * @returns 
 */
export const remplaceSlashNByBr = (str) => {
  let temp = str?.replace(/\n+$/, '');
  return  temp?.replace(/\n/g, '<br/>');
}

/**
 * 
 * @param {*} list 
 * @param {*} idPartenaire 
 * @param {*} typePartenariat 
 * @returns 
 */
export const filtreByPartenaire =  (list,idPartenaire, typePartenariat) => {
  if(idPartenaire>0) {
    let newList = [];
    list?.forEach(e => {
      if(e?.idPartenaire === idPartenaire && e?.typePartenariat === typePartenariat) {
        newList.push(e);
      }
     
    });

    return newList;
  } 
  return list;
}

// Fonction pour générer les options de temps avec un step de 15 minutes
export const generateTimeOptions = () => {
  const step = 30; // Step de 15 minutes
  let hour = 0;
  let minute = 0;
  const timeOptions = [];

  // Boucle pour générer les heures et minutes
  for (let i = 0; i < 24 * 60; i += step) {
    // Formatage des heures et minutes
    const formattedHour = hour < 10 ? `0${hour}` : hour;
    const formattedMinute = minute < 10 ? `0${minute}` : minute;
    const label = `${formattedHour} h ${formattedMinute}`; // Format du label
    const value = `${formattedHour}:${formattedMinute}`; // Format de la valeur

    // Ajouter l'option dans le tableau (label, value)
    timeOptions.push({ label, value });

    // Mettre à jour l'heure et les minutes
    minute += step;
    if (minute === 60) {
      minute = 0;
      hour++;
    }
  }

  return timeOptions;
};

export  const getNumbersBetweenDates = (start, end) => {
    const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
    const diffInTime = Math.abs(moment(end, 'DD/MM/YYYY').toDate() - moment(start, 'DD/MM/YYYY').toDate());
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays;
};

export  const getNumbersBetweenDatesDayJs = (start, end) => {
  const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
  const diffInTime = Math.abs(dayjs(end).toDate() - dayjs(start).toDate());
  const diffInDays = Math.round(diffInTime / oneDay);

  return diffInDays;
};

export const convertDateSiFormatFr = (date) => {
  let retour = date;

  // Vérifier si la date n'est pas vide ou composée uniquement d'espaces
  if (date && date.trim() !== '') {
    // Diviser la date en parties
    const tab = date.split("-");

    // Vérifier si le tableau contient exactement 3 éléments et que l'année est bien en 4 caractères
    if (tab.length === 3 && tab[2].length === 4) {
      // Convertir la date au format YYYY-MM-DD (fr -> us)
      retour = `${tab[2]}-${tab[1]}-${tab[0]}`;
    }else {
       const tab2 = date.split("/");
       if (tab2.length === 3 && tab2[2].length === 4) {
        // Convertir la date au format YYYY-MM-DD (fr -> us)
        retour = `${tab2[2]}-${tab2[1]}-${tab2[0]}`;
      }
    }
  }

  return retour;
};

/**
 * get tarif en fonction du devise pour airbnb
 * @param {*} tarifList 
 * @param {*} idDevise 
 * @returns 
 */ 
 export  const  getPrixNuiteByDevise =(tarifList,idDevise) =>{
    const tarif = tarifList.find(item => item.idDevise === idDevise);
    return tarif ? tarif.prixNuite : null;
}

